import { render, staticRenderFns } from "./EmailSmsLogDetail.vue?vue&type=template&id=684d24dc&scoped=true"
import script from "./EmailSmsLogDetail.vue?vue&type=script&lang=js"
export * from "./EmailSmsLogDetail.vue?vue&type=script&lang=js"
import style0 from "./EmailSmsLogDetail.vue?vue&type=style&index=0&id=684d24dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684d24dc",
  null
  
)

export default component.exports